import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";

// @material-ui/icons
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";

import tasksStyle from "assets/jss/material-dashboard-pro-react/components/tasksStyle.jsx";

import UserImage from "../Image/UserImage";
import moment from "moment";
import { Tooltip } from "@material-ui/core";
import Info from "../Typography/Info";

import { infoColor, primaryColor } from "assets/jss/material-dashboard-pro-react.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentAltDots, faFile } from "@fortawesome/pro-solid-svg-icons";

class NotesList extends React.Component {
  render() {
    const { classes, notes } = this.props;
    return (
      <Table className={classes.table}>
        <TableBody className={classes.tableBody}>
          {notes.map((note, index) => (
            <TableRow key={note.id} onClick={() => this.props.onNoteClick(note)} className={classes.tableRow} style={{ ...((index + 1) === notes.length ? { borderBottom: '0' } : {}) }}>
              <TableCell style={{ border: '0', padding: 0 }}>
                <Tooltip
                  id="tooltip-top-start"
                  title={note.user.name + (note.user.surname ? " " + note.user.surname : "")}
                  placement="top"
                  classes={{ tooltip: classes.tooltip }}
                >
                  <div className={classes.tableCellImage}>
                    <UserImage image={note.user.image} className={classes.tableImage} style={{ height: 34, width: 34 }} />
                  </div>
                </Tooltip>
              </TableCell>
              <TableCell className={classes.tableCell}>
                {note.message}
              </TableCell>
              <TableCell className={classes.tableActions}>
                {
                  note.replies.length > 0 ?
                    <span style={{ display: 'inline-block', fontSize: '0.9em', color: infoColor, padding: '2px 6px', border: '1px solid ' + infoColor, borderRadius: 8, minWidth: 38 }}>
                      {note.replies.length}&nbsp;&nbsp;
                      <FontAwesomeIcon icon={faCommentAltDots} color={infoColor} size='sm' />
                    </span>
                    :
                    null
                }
                {
                  note.uploads && note.uploads.length > 0 ?
                    <span style={{ display: 'inline-block', fontSize: '0.9em', color: primaryColor, padding: '2px 6px', border: '1px solid ' + primaryColor, borderRadius: 8, minWidth: 38 }}>
                      {note.uploads.length}&nbsp;&nbsp;
                      <FontAwesomeIcon icon={faFile} color={primaryColor} size='sm' />
                    </span>
                    :
                    null
                }
              </TableCell>
              <TableCell className={classes.tableActions} style={{ textAlign: 'right' }}>
                <span style={{ fontWeight: 'bold', display: 'inline-block', width: 167 }}>{moment(note.when).format('D MMMM YYYY @ HH:mm')}</span>
              </TableCell>
              <TableCell className={classes.tableActions}>
                <KeyboardArrowRight color="default" />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }
}

export default withStyles(tasksStyle)(NotesList);
